<template>
    <div class="card-container">
        <slot></slot>
    </div>
</template>
<style lang="scss" scoped>
.card-container {
    background: var(--colors-common-background-default);
    border-radius: var(--spacing-1);
    box-shadow: var(--elevation-1);
    padding: var(--spacing-4);

    & + & {
        margin: var(--spacing-4) 0 0;
    }
}
</style>
